import * as z from "zod";
import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const referenceObject = () =>
  z
    .object({
      id: requiredString(),
    })
    .or(z.literal(undefined))
    .or(z.literal(null))
    .refine((val) => !!val && !!val.id?.trim(), {
      message: REQUIRED_MESSAGE,
    });

export const departmentSchema = z.object({
  name: requiredString(),
  status: z.optional(z.string()).default("draft"),
  head: referenceObject(),
  coordinators: z.array(referenceObject()).optional(),
});
